import React, { Fragment, useContext, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { MediaContext } from "../../common/media-context";
import {
  useContentBadges,
  useUnlinkBadgeFromContent,
} from "../../../manage-badges/badgesServices";
import { isEmpty } from "ramda";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import { useSnackAlert } from "../../../common/use-snackAlert";

import Grid from "@mui/material/Grid";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import IconButton from "@mui/material/IconButton";

import Badge from "../../../manage-badges/Badge";
import BadgesDialog from "./BadgesDialog";
import ColumnHeader from "./ColumnHeader";

const useStyles = makeStyles(theme => ({
  tile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "grey",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.palette.primary.light,
    borderRadius: 15,
  },
}));

const ContentBadges = () => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const { SnackAlert, showAlert } = useSnackAlert();

  const contentBadgesResults = useContentBadges(context.media.id);

  const [contentBadges, setContentBadges] = useState([]);
  useEffect(() => {
    if (contentBadgesResults.isSuccess) {
      setContentBadges(contentBadgesResults.data);
    }
  }, [contentBadgesResults.isSuccess, contentBadgesResults.data]);

  const unlinkBadgeFromContent = useUnlinkBadgeFromContent();
  const handleRemoveBadge = async badge => {
    try {
      await unlinkBadgeFromContent.mutateAsync({
        resourceIds: {
          mediaId: context.media.id,
          badgeId: badge.id,
        },
      });
    } catch (err) {
      showAlert("error", [err.message]);
    }
  };

  //-- Manage Badge Dialog
  const [open, setOpen] = useState(false);
  const openBadgeDialog = () => setOpen(true);
  const onCancel = () => setOpen(false);

  return (
    <Fragment>
      <SnackAlert />
      <BadgesDialog visible={open} onCancel={onCancel} />
      <ColumnHeader
        header="Badges"
        buttonText="Add Badges"
        onClick={openBadgeDialog}
      />
      {contentBadgesResults.isSuccess && isEmpty(contentBadges) ? (
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          style={{ height: 50 }}
        >
          <i>No badges have been added</i>
        </Grid>
      ) : (
        <ImageList>
          {contentBadges.map(badge => (
            <ImageListItem key={badge.id} classes={{ tile: classes.tile }}>
              <Badge badge={badge} orientation="grid" />
              <ImageListItemBar
                title={badge.fileName}
                subtitle={badge.fileType}
                actionIcon={
                  <IconButton
                    onClick={() => handleRemoveBadge(badge)}
                    style={{ color: "white" }}
                    size="large"
                  >
                    <FontAwesomeIcon icon={faCircleXmark} />
                  </IconButton>
                }
              />
            </ImageListItem>
          ))}
        </ImageList>
      )}
    </Fragment>
  );
};

export default ContentBadges;
